//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsMediaLibraryPageEnabled = createHasFeatureSelector(
  FeatureNames.MediaLibraryPage,
);

export const getIsMediaLibrarySourcedOrganicContentEnabled =
  createHasFeatureSelector(FeatureNames.MediaLibrarySourcedOrganicContent);

export const getIsTributarySelfServeEnabled = createHasFeatureSelector(
  FeatureNames.TributarySelfServe,
);

// TODO: PD-319070 - Remove media_library_streams feature flag
export const getIsMediaLibraryStreamsEnabled = createHasFeatureSelector(
  FeatureNames.MediaLibraryStreams,
);

export const getIsSimilarityToApprovedEnabled = createHasFeatureSelector(
  FeatureNames.SimilarityToApproved,
);
